// 检测是否为触摸设备
const isTouchDevice = () => {
  return window.innerWidth < 750;
};

if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          gallery: this.querySelector('[id^="Slider-Gallery"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          currentPageElement: this.querySelector('.slider-counter--current'),
          pageTotalElement: this.querySelector('.slider-counter--total'),
          dots: this.querySelectorAll('.slider-dot'),
          closeVideoBtn: this.querySelector('#product_video_close'),
          headers: document.querySelectorAll('.shopify-section-group-header-group'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button').addEventListener('click', (event) => {
            this.setActiveMedia(mediaToSwitch.dataset.target, mediaToSwitch.dataset.mediaPosition, false, event);
          });
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

        // 新增：自动轮播相关初始化
        this.autoplayInterval = 2000; // 自动轮播间隔，单位毫秒
        this.autoplayTimer = null;
        this.isAutoplaying = false;
        this.videoPlaying = false; // 记录当前是否正在播放视频
        this.isHovering = false; // 记录当前是否处于鼠标悬停状态

        // 新增：鼠标悬停时开启自动轮播，离开时停止
        this.elements.gallery.addEventListener('mouseenter', () => {
          if (isTouchDevice()) return;
          this.isHovering = true;
          if (!this.videoPlaying) {
            this.startAutoplay();
          }
        });
        this.elements.gallery.addEventListener('mouseleave', () => {
          this.isHovering = false;
          this.stopAutoplay();
        });

        // 新增：关闭视频模式
        // this.elements.closeVideoBtn.addEventListener('click', (event) => {
        //   this.toggleVideoModal(false);
        //   this.goToNextSlide();
        // });

        // 为每个dot添加点击事件监听器
        this.elements.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.onDotClick(index + 1));
        });
      }

      // 新增：处理dot点击事件
      onDotClick(position) {
        const mediaToSwitch = this.elements.thumbnails.querySelector(`[data-media-position="${position}"]`);
        if (mediaToSwitch) {
          this.setActiveMedia(mediaToSwitch.dataset.target, position, false);
        }
      }

      // 新增：打开或关闭视频模式
      toggleVideoModal(open) {
        if (open) {
          this.elements.headers.forEach((header) => {
            header.style.zIndex = 0;
            document.body.classList.add('overflow-hidden');
          });
          this.videoPlaying = true;
        } else {
          this.elements.headers.forEach((header) => {
            header.style.zIndex = 4;
            document.body.classList.remove('overflow-hidden');
          });
          this.videoPlaying = false;
        }
      }

      // 新增：开始自动轮播
      startAutoplay() {
        if (this.isAutoplaying) return;
        this.isAutoplaying = true;
        this.autoplayTimer = setInterval(() => this.goToNextSlide(), this.autoplayInterval);
      }

      // 新增：停止自动轮播
      stopAutoplay() {
        if (!this.isAutoplaying) return;
        this.isAutoplaying = false;
        clearInterval(this.autoplayTimer);
      }

      // 新增：切换到下一张幻灯片
      goToNextSlide() {
        const currentPage = parseInt(this.elements.currentPageElement.textContent);
        const totalPages = parseInt(this.elements.pageTotalElement.textContent);
        const nextPage = (currentPage % totalPages) + 1;
        const nextMedia = this.elements.thumbnails.querySelector(`[data-media-position="${nextPage}"]`);
        if (nextMedia) {
          this.setActiveMedia(nextMedia.dataset.target, nextPage, false);
        }
      }

      // 新增：重置自动轮播计时器
      resetAutoplayTimer() {
        if (this.isAutoplaying) {
          this.stopAutoplay();
          this.startAutoplay();
        }
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
        this.updateIndex(event.detail.currentPage);

        // 修改：在幻灯片变化时重置自动轮播计时器
        this.resetAutoplayTimer();
      }

      updateIndex(number) {
        this.elements.currentPageElement.textContent = number;
        if (this.elements.dots) {
          this.elements.dots.forEach((dot, index) => {
            if (index + 1 === +number) {
              dot.classList.add('slider-dot--active');
            } else {
              dot.classList.remove('slider-dot--active');
            }
          });
        }
      }

      setActiveMedia(mediaId, position, prepend, event) {
        this.stopAutoplay(); // 用户交互时停止自动轮播

        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.updateIndex(position);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element, index) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail &&
              activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);

        if (this.isHovering) {
          this.startAutoplay();
        }
        // 交互结束后重新开始自动轮播, 点击视频不继续轮播
        // const mediaType = event && event.target.getAttribute('aria-media-type');
        // if (mediaType !== 'video' && mediaType !== 'external_video') {
        //   this.startAutoplay();
        // } else {
        //   this.toggleVideoModal(true);
        // }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
